import React, { useEffect, useRef, useState } from "react";

// Video che scarica il file solo quando entra (quasi) in vista; src mobile opzionale.
export default function LazyVideo({ src, mobileSrc, poster, ...rest }) {
  const ref = useRef(null);
  const [load, setLoad] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el || !("IntersectionObserver" in window)) { setLoad(true); return; }
    const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setLoad(true); io.disconnect(); } }, { rootMargin: "300px" });
    io.observe(el);
    return () => io.disconnect();
  }, []);
  const url = mobileSrc && window.innerWidth < 768 ? mobileSrc : src;
  return <video ref={ref} src={load ? url : undefined} poster={poster} preload="none" {...rest} />;
}
